import DownloadIcon from "@mui/icons-material/Download";
import {
	Alert,
	Box,
	Button,
	Checkbox,
	Chip,
	FormControlLabel,
	Paper,
	Snackbar,
	styled,
	Tab,
	Tabs,
	TextField,
	Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "context";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";

const VisuallyHiddenInput = styled("input")({
	clip: "rect(0 0 0 0)",
	clipPath: "inset(50%)",
	height: 1,
	overflow: "hidden",
	position: "absolute",
	bottom: 0,
	left: 0,
	whiteSpace: "nowrap",
	width: 1,
});

const StatusChip = styled(Chip)(({ theme, status }) => ({
	fontWeight: "bold",
	...(status === "toApprove" && {
		backgroundColor: theme.palette.warning.light,
		color: theme.palette.warning.contrastText,
	}),
	...(status === "approved" && {
		backgroundColor: theme.palette.success.light,
		color: theme.palette.success.contrastText,
	}),
	...(status === "rejectedDone" && {
		backgroundColor: theme.palette.info.light,
		color: theme.palette.info.contrastText,
	}),
	...(status === "rejected" && {
		backgroundColor: theme.palette.error.light,
		color: theme.palette.error.contrastText,
	}),
}));

/*{
      id: 'doc1',
      required: true,
      label: 'Durc',
      status: 'rejectedDone',
      file: null,
      uploaded_at: '2023-05-15T10:30:00Z',
      additionalInformation: [
        { id: 'expiration', type: 'date', value: '', required: true, label: 'Data di scadenza' },
        { id: 'info1', type: 'text', value: '', required: true, label: 'Emittente' },
        { id: 'info2', type: 'number', value: '', required: false, label: 'Codice DURC' },
      ],
    },
    {
      id: 'doc2',
      required: true,
      label: 'Visura',
      status: 'toUpload',
      url: 'https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80',
      uploaded_at: '2023-05-10T14:45:00Z',
      approved_by: 'Mario Rossi',
      additionalInformation: [
        { id: 'expiration', type: 'date', value: '2024-05-10', required: true, label: 'Data di scadenza' },
        { id: 'info1', type: 'text', value: 'Camera di Commercio', required: true, label: 'Emittente' },
        { id: 'info2', type: 'number', value: '123456', required: true, label: 'Codice Visura' },
      ],
    },
    {
      id: 'doc3',
      required: false,
      status: 'rejected',
      rejectionReason: 'La data di scadenza non è valida',
      label: 'Patente muletto',
      url: 'https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80',
      uploaded_at: '2023-05-12T09:15:00Z',
      rejected_by: 'Luca Bianchi',
      additionalInformation: [
        { id: 'info5', type: 'text', value: 'Default text', required: false, label: 'Emittente' },
        { id: 'expiration', type: 'date', value: '2025-05-01', required: true, label: 'Data di scadenza' },
      ],
    },
    {
      id: 'doc4',
      required: false,
      status: 'toUpload',
      label: 'Patente macchina',
      file: null,
      uploaded_at: '2023-05-14T16:20:00Z',
      additionalInformation: [
        { id: 'info5', type: 'text', value: '', required: false, label: 'Emittente' },
        { id: 'expiration', type: 'date', value: '', required: true, label: 'Data di scadenza' },
      ],
    },*/

const ManageSecurityDocument = () => {
	const authContext = useContext(AuthContext);
	const [errors, setErrors] = useState({});
	const { type, id, instanceName } = useParams();
	const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
	const [viewingInfo, setViewingInfo] = useState(null);
	const [activeTab, setActiveTab] = useState(0);
	const [rejectReason, setRejectReason] = useState({});
	const [documents, setDocuments] = useState([]);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const handleSetNotification = (msg, severityType) => {
		if (severityType === "success") {
			toast.success(msg, { id: "manage-security-document-toast" });
		} else {
			toast.error(msg, { id: "manage-security-document-toast" });
		}
	};

	function fetchDocuments() {
		if (type === "supplier") {
			setLoading(true);
			apiService
				.get("/get-documents", { supplier_id: id }, {})
				.then((response) => {
					if (response) {
						setDocuments(response);
						setLoading(false);
					}
				})
				.catch((error) => {
					handleSetNotification(
						"Errore durante la chiamata al server, codice d'errore #08514262429906",
						"error"
					);
					setLoading(false);
				});
		} else if (type === "user") {
			setLoading(true);
			apiService
				.get("/get-documents", { user_id: id, external: "true" }, {})
				.then((response) => {
					if (response) {
						setDocuments(response);
						setLoading(false);
					}
				})
				.catch((error) => {
					handleSetNotification(
						"Errore durante la chiamata al server, codice d'errore #0859583719906",
						"error"
					);
					setLoading(false);
				});
		}
	}

	useEffect(() => {
		if (type && id) {
			fetchDocuments();
		}
	}, [type, id]);

	useEffect(() => {
		console.log("Documents:", documents);
	}, [documents]);

	const handleFileChange = (docId, event) => {
		setDocuments((prevDocs) =>
			prevDocs.map((doc) =>
				doc.id === docId ? { ...doc, file: event.target.files[0], status: "toApprove" } : doc
			)
		);
	};

	const handleAdditionalInfoChange = (docId, infoId, value) => {
		setDocuments((prevDocs) =>
			prevDocs.map((doc) =>
				doc.id === docId
					? {
							...doc,
							additionalInformation: doc.additionalInformation.map((info) =>
								info.id === infoId ? { ...info, value } : info
							),
						}
					: doc
			)
		);
	};

	const handleDeleteFile = (docId) => {
		setDocuments((prevDocs) =>
			prevDocs.map((doc) => (doc.id === docId ? { ...doc, file: null, status: "toApprove" } : doc))
		);
	};

	const validateDocuments = (docs) => {
		const newErrors = {};

		docs.forEach((doc) => {
			if (doc.required && (doc.status === "toApprove" || doc.status === "rejectedDone") && !doc.file) {
				newErrors[doc.id] = newErrors[doc.id] || {};
				newErrors[doc.id].file = "File richiesto";
			}

			if (doc.status === "toApprove" || doc.status === "rejectedDone") {
				doc.additionalInformation.forEach((info) => {
					if (info.required && !info.value) {
						newErrors[doc.id] = newErrors[doc.id] || {};
						newErrors[doc.id][info.id] = `Campo richiesto`;
					}
				});
			}
		});

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSave = () => {
		let docsToValidate = documents.filter((doc) => doc.status === "toApprove" || doc.status === "rejectedDone");

		if (validateDocuments(docsToValidate)) {
			onSave(docsToValidate);
		} else {
			setShowErrorSnackbar(true);
		}
	};

	const handleDownload = (url) => {
		window.open(url, "_blank");
	};

	const handleApprove = (docId) => {
		/*setDocuments((prevDocs) =>
      prevDocs.map((doc) =>
        doc.id === docId ? { ...doc, status: 'approved', approved_by: 'Current User' } : doc
      )
    );*/

		/*
		 * Aggiungi la logica per l'approvazione del documento
		 */

		apiService
			.post(
				"/rectification-documents/",
				{},
				{ documentId: docId, supplier: type === "supplier", status: true, motivation: "" }
			)
			.then((response) => {
				if (response) {
					fetchDocuments();
				}
			})
			.catch((error) => {
				handleSetNotification("Errore durante la chiamata al server, codice d'errore #0859906", "error");
			});
	};

	const handleReject = (docId) => {
		if (rejectReason[docId]) {
			/*
      setDocuments((prevDocs) =>
        prevDocs.map((doc) =>
          doc.id === docId ? { ...doc, status: 'rejected', rejected_by: 'Current User', rejectionReason: rejectReason[docId] } : doc
        )
      );
      setRejectReason({...rejectReason,[docId]:''});*/

			apiService
				.post(
					"/rectification-documents/",
					{},
					{ documentId: docId, supplier: type === "supplier", status: false, motivation: rejectReason[docId] }
				)
				.then((response) => {
					if (response) {
						fetchDocuments();
					}
				})
				.catch((error) => {
					handleSetNotification(
						"Errore durante la chiamata al server, codice d'errore #085837379906",
						"error"
					);
				});
		} else {
			setErrors((prevErrors) => ({
				...prevErrors,
				[docId]: { ...prevErrors[docId], rejectReason: "Motivo di rifiuto richiesto" },
			}));
		}
	};

	const renderDocumentContent = (doc) => {
		switch (doc.status) {
			case "toApprove":
			case "approved":
			case "rejectedDone":
				return (
					<>
						<Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
							<Button
								variant="outlined"
								startIcon={<DownloadIcon />}
								onClick={() => handleDownload(doc.url)}
								sx={{
									maxWidth: 200,
									textOverflow: "ellipsis",
									overflow: "hidden",
									whiteSpace: "nowrap",
									fontSize: "0.875rem",
									backgroundColor: "white",
									borderColor: "black!important",
									boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
									color: "black!important",
									transition: "box-shadow 0.3s ease-in-out",
									"&:hover, &:focus, &:active": {
										backgroundColor: "white",
										boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
										borderColor: "black!important",
										color: "black!important",
									},
								}}
							>
								Scarica
							</Button>
							{doc.status === "approved" ? (
								<StatusChip label="Approvato" status={doc.status} />
							) : (
								<StatusChip
									label={doc.status === "toApprove" ? "Da approvare" : "Rettificato"}
									status={doc.status}
								/>
							)}
						</Box>
						{errors[doc.id]?.file && (
							<Typography color="error" variant="caption">
								{errors[doc.id].file}
							</Typography>
						)}
						{doc.file && (
							<Typography variant="body2" color="text.secondary" sx={{ marginTop: 1 }}>
								File selezionato: {doc.file.name}
							</Typography>
						)}
						{renderAdditionalInfo(doc, false)}
						<hr
							style={{
								border: "none",
								height: "1px",
								background:
									"linear-gradient(to right, rgba(128, 128, 128, 0.1), gray, rgba(128, 128, 128, 0.1))",
								margin: "20px 0",
							}}
						/>
						<Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
							{doc.status !== "approved" && (
								<Button variant="contained" color="success" onClick={() => handleApprove(doc.id)}>
									Approva
								</Button>
							)}
							<Button variant="contained" color="error" onClick={() => handleReject(doc.id)}>
								Rifiuta
							</Button>
						</Box>
						<TextField
							label="Motivo del rifiuto"
							value={rejectReason[doc.id]}
							onChange={(e) => {
								setRejectReason((prevRejectReason) => ({
									...prevRejectReason,
									[doc.id]: e.target.value,
								}));
							}}
							error={!!errors[doc.id]?.rejectReason}
							helperText={errors[doc.id]?.rejectReason}
							fullWidth
							margin="normal"
						/>
					</>
				);
			case "rejected":
				return (
					<>
						<Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
							<Button
								variant="outlined"
								startIcon={<DownloadIcon />}
								onClick={() => handleDownload(doc.url)}
								sx={{
									maxWidth: 200,
									textOverflow: "ellipsis",
									overflow: "hidden",
									whiteSpace: "nowrap",
									fontSize: "0.875rem",
									backgroundColor: "white",
									borderColor: "black!important",
									boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
									color: "black!important",
									transition: "box-shadow 0.3s ease-in-out",
									"&:hover, &:focus, &:active": {
										backgroundColor: "white",
										boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
										borderColor: "black!important",
										color: "black!important",
									},
								}}
							>
								Scarica
							</Button>
							<StatusChip
								label={doc.status === "approved" ? "Approvato" : "Da rettificare"}
								status={doc.status}
							/>
						</Box>
						{doc.status === "rejected" && doc.rejectionReason && (
							<Typography color="error" variant="body2" sx={{ marginBottom: 2 }}>
								Motivo di rifiuto: {doc.rejectionReason}
							</Typography>
						)}
						{renderAdditionalInfo(doc, false)}
					</>
				);
			default:
				return null;
		}
	};

	const renderAdditionalInfo = (doc, editable) => (
		<>
			{doc.additionalInformation.map((info) => (
				<React.Fragment key={info.id}>
					{(info.type === "text" || info.type === "date" || info.type === "number") && (
						<TextField
							label={info.label}
							value={info.value}
							required={info.required}
							error={!!errors[doc.id]?.[info.id]}
							helperText={errors[doc.id]?.[info.id]}
							onChange={(e) => handleAdditionalInfoChange(doc.id, info.id, e.target.value)}
							fullWidth
							disabled={!editable}
							margin="normal"
						/>
					)}
					{info.type === "bool" && (
						<FormControlLabel
							sx={{ marginTop: 1 }}
							control={
								<Checkbox
									checked={info.value}
									onChange={(e) => handleAdditionalInfoChange(doc.id, info.id, e.target.checked)}
									disabled={!editable}
								/>
							}
							label={info.label || "Booleano"}
						/>
					)}
					{/*info.type === 'date' && (
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
              <DatePicker
                label={info.label}
                value={info.value ? dayjs(info.value) : null}
                onChange={(newValue) => handleAdditionalInfoChange(
                  doc.id,
                  info.id,
                  newValue ? dayjs(newValue).format('YYYY-MM-DD') : null
                )}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    margin: "normal",
                    error: !!errors[doc.id]?.[info.id],
                    helperText: errors[doc.id]?.[info.id],
                    disabled: !editable,
                  },
                }}
              />
            </LocalizationProvider>
          )*/}
				</React.Fragment>
			))}
		</>
	);

	const uploadedDocs = documents?.filter((doc) => ["approved", "toApprove"].includes(doc.status));
	const toRectifyDocs = documents?.filter((doc) => ["rejected", "rejectedDone"].includes(doc.status));
	const rejectedDocs = documents?.filter((doc) => doc.status === "rejected");
	const rejectedDoneDocs = documents?.filter((doc) => doc.status === "rejectedDone");
	const onSave = (docsToValidate) => {
		console.log("Documents to save:", docsToValidate); // Placeholder for actual save logic
	};

	return (
		<>
			<DashboardLayout>
				{authContext.hasAuth("UPSERT_SECURITY_MANAGMENT") ? (
					<>
						<DashboardNavbar />
						<Box sx={{ width: "100%" }}>
							<center>
								<Typography variant="h4" gutterBottom sx={{ mt: 4, mb: 3 }}>
									DOCUMENTI SICUREZZA DI {instanceName.toUpperCase()}
								</Typography>
								<Button
									onClick={() => navigate(-2)}
									type="submit"
									variant="contained"
									component="span"
									sx={{
										backgroundColor: "#514f4f",
										color: "white!important",
										mb: 2,
										width: "220px",
										height: "50px",
										fontSize: "16px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: "8px",
									}}
								>
									Indietro
								</Button>
							</center>
							{!loading ? (
								<>
									<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
										<Tabs
											value={activeTab}
											onChange={(_, newValue) => setActiveTab(newValue)}
											aria-label="document tabs"
										>
											<Tab label="Documenti caricati" />
											<Tab
												label={
													<>
														Rettificazioni
														{rejectedDocs?.length > 0 && (
															<Chip
																label={rejectedDocs.length}
																color="error"
																size="small"
																sx={{ ml: 1 }}
															/>
														)}
														{rejectedDoneDocs?.length > 0 && (
															<Chip
																label={rejectedDoneDocs.length}
																color="info"
																size="small"
																sx={{ ml: 1 }}
															/>
														)}
													</>
												}
											/>
										</Tabs>
									</Box>
									<Box sx={{ padding: 2, display: "flex", flexDirection: "column", gap: 3 }}>
										{activeTab === 0 &&
											(uploadedDocs?.length > 0 ? (
												uploadedDocs.map((doc) => (
													<Paper
														key={doc.id}
														elevation={3}
														sx={{ padding: 3, borderRadius: 2 }}
													>
														<Box
															sx={{
																display: "flex",
																justifyContent: "space-between",
																alignItems: "center",
																marginBottom: 2,
															}}
														>
															<Typography variant="h6">
																{doc.label}{" "}
																{doc.required ? "(Necessario)" : "(Opzionale)"}
															</Typography>
														</Box>
														<Typography variant="body2" sx={{ mt: 2 }}>
															Caricato il: {doc.uploaded_at}
														</Typography>
														{doc.status === "approved" && (
															<Typography variant="body2">
																Approvato da: {doc.approved_by}
															</Typography>
														)}
														{doc.status === "rejected" && (
															<Typography variant="body2">
																Rifiutato da: {doc.rejected_by}
															</Typography>
														)}
														<hr
															style={{
																border: "none",
																height: "1px",
																background:
																	"linear-gradient(to right, rgba(128, 128, 128, 0.1), gray, rgba(128, 128, 128, 0.1))",
																margin: "20px 0",
															}}
														/>
														{renderDocumentContent(doc)}
													</Paper>
												))
											) : (
												<Typography
													variant="body1"
													sx={{ textAlign: "center", color: "text.secondary" }}
												>
													Nessun documento caricato da visualizzare.
												</Typography>
											))}
										{activeTab === 1 &&
											(toRectifyDocs?.length > 0 ? (
												toRectifyDocs.map((doc) => (
													<Paper
														key={doc.id}
														elevation={3}
														sx={{ padding: 3, borderRadius: 2 }}
													>
														<Box
															sx={{
																display: "flex",
																justifyContent: "space-between",
																alignItems: "center",
																marginBottom: 2,
															}}
														>
															<Typography variant="h6">
																{doc.label}{" "}
																{doc.required ? "(Necessario)" : "(Opzionale)"}
															</Typography>
														</Box>
														<Typography variant="body2" sx={{ mt: 2 }}>
															Caricato il: {doc.uploaded_at}
														</Typography>
														{doc.status === "approved" && (
															<Typography variant="body2">
																Approvato da: {doc.approved_by}
															</Typography>
														)}
														{doc.status === "rejected" && (
															<Typography variant="body2">
																Rifiutato da: {doc.rejected_by}
															</Typography>
														)}
														{doc.status === "rejectedDone" && (
															<>
																<Typography variant="body2">
																	Rifiutato da: {doc.rejected_by}
																</Typography>
																<Typography variant="body2">
																	Motivo di rifiuto: {doc.rejectionReason}
																</Typography>
															</>
														)}
														<hr
															style={{
																border: "none",
																height: "1px",
																background:
																	"linear-gradient(to right, rgba(128, 128, 128, 0.1), gray, rgba(128, 128, 128, 0.1))",
																margin: "20px 0",
															}}
														/>
														{renderDocumentContent(doc)}
													</Paper>
												))
											) : (
												<Typography
													variant="body1"
													sx={{ textAlign: "center", color: "text.secondary" }}
												>
													Nessun documento da rettificare.
												</Typography>
											))}
									</Box>
								</>
							) : (
								<center>
									<CircularProgress size={120} sx={{ marginTop: "250px", color: "#2b84ea" }} />
								</center>
							)}
							<Snackbar
								open={showErrorSnackbar}
								autoHideDuration={6000}
								onClose={() => setShowErrorSnackbar(false)}
								anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
							>
								<Alert
									onClose={() => setShowErrorSnackbar(false)}
									severity="error"
									sx={{ width: "100%" }}
								>
									Si prega di compilare tutti i campi necessari prima di continuare.
								</Alert>
							</Snackbar>
						</Box>
					</>
				) : (
					<MDBox sx={{ mt: 8 }}>
						<MDAlert color="error">Non hai i permessi per visualizzare questa pagina.</MDAlert>
					</MDBox>
				)}
			</DashboardLayout>
		</>
	);
};

export default ManageSecurityDocument;
